import { motion } from "framer-motion";
import { useState } from "react";

export default function Consulting() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(form);
    alert("Request Submitted ✅");
  };

  return (
    <section
      className="relative py-20 px-6 text-white"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.85), rgba(249,122,8,0.3)), url('/assets/s1.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="max-w-3xl mx-auto">
        {/* 🔥 Heading */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-orange-400 mb-4">
            Free Consultation 💡
          </h2>

          <p className="text-white/80">
            Get expert advice for your solar setup. Fill the form and our team
            will contact you shortly.
          </p>
        </motion.div>

        {/* 🔥 FORM */}
        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-black/40 backdrop-blur-xl p-8 rounded-2xl border border-orange-500/20 shadow-[0_0_30px_rgba(249,115,22,0.2)]"
        >
          {/* Name */}
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={form.name}
            onChange={handleChange}
            className="w-full mb-4 p-3 bg-black/60 border border-orange-400/30 rounded-lg focus:outline-none focus:border-orange-400"
            required
          />

          {/* Email */}
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={form.email}
            onChange={handleChange}
            className="w-full mb-4 p-3 bg-black/60 border border-orange-400/30 rounded-lg focus:outline-none focus:border-orange-400"
            required
          />

          {/* Phone */}
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={form.phone}
            onChange={handleChange}
            className="w-full mb-4 p-3 bg-black/60 border border-orange-400/30 rounded-lg focus:outline-none focus:border-orange-400"
            required
          />

          {/* Service */}
          <select
            name="service"
            value={form.service}
            onChange={handleChange}
            className="w-full mb-4 p-3 bg-black/60 border border-orange-400/30 rounded-lg focus:outline-none focus:border-orange-400"
            required
          >
            <option value="">Select Service</option>
            <option>Solar Installation</option>
            <option>Battery Storage</option>
            <option>Maintenance</option>
            <option>Consulting</option>
          </select>

          {/* Message */}
          <textarea
            name="message"
            placeholder="Your Message"
            rows="4"
            value={form.message}
            onChange={handleChange}
            className="w-full mb-6 p-3 bg-black/60 border border-orange-400/30 rounded-lg focus:outline-none focus:border-orange-400"
          />

          {/* Button */}
          <button
            type="submit"
            className="w-full py-3 bg-gradient-to-r from-orange-400 to-yellow-500 text-black font-bold rounded-lg hover:scale-105 transition"
          >
            Submit Request 🚀
          </button>
        </motion.form>
      </div>
    </section>
  );
}
